import { render } from "./index.vue?vue&type=template&id=052e36f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=052e36f8&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=052e36f8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052e36f8"]])

export default __exports__